import { render, staticRenderFns } from "./formaciones.vue?vue&type=template&id=565c226a&scoped=true&"
import script from "./formaciones.vue?vue&type=script&lang=js&"
export * from "./formaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565c226a",
  null
  
)

export default component.exports